import axios from 'axios';
import {
  RequestQueryBuilder,
  CreateQueryParams,
  CondOperator,
} from '@dataui/crud-request';

import {
  OPPORTUNITIES_FETCH,
  OPPORTUNITY_OPTIONS_FETCH,
  OPPORTUNITY_OPTION_GET,
} from './types';

export default {
  [OPPORTUNITIES_FETCH]: async ({ commit }, payload) => {
    return axios.get(payload.endpoint).then((response) => {
      commit(OPPORTUNITIES_FETCH, response.data);
    });
  },
  [OPPORTUNITY_OPTIONS_FETCH]: async ({ commit }) => {
    return axios.get('/data-api/opportunity-option').then((response) => {
      commit(OPPORTUNITY_OPTIONS_FETCH, response.data);
    });
  },
  [OPPORTUNITY_OPTION_GET]: async ({ commit }, payload) => {
    const query = {
      filter: [
        {
          field: 'opportunity.id',
          operator: CondOperator.EQUALS,
          value: payload.id,
        },
      ],
      join: [{ field: 'opportunity' }],
    };
    const queryString = RequestQueryBuilder.create(query).query();
    return axios
      .get(`/data-api/opportunity-option?${queryString}`)
      .then((response) => {
        commit(OPPORTUNITY_OPTIONS_FETCH, response.data);
      });
  },
};
